import { BOSToasterRef } from 'Components/Generic/BOSToaster';
import {
  getSaveToasterProps,
  getUndoToasterProps,
} from 'Components/Generic/BOSToasterUtil';
import { useEffect, useRef, useState } from 'react';

export const useUndoableSaveAction = ({
  originalObject = {},
  undoFunction = () => {},
  onUndo = () => {},
  objectType = '',
}) => {
  const toasterProps = useRef(undefined);

  const [undoObject, setUndoObject] = useState(undefined);

  useEffect(() => {
    if (
      undoObject &&
      originalObject &&
      Object.keys(originalObject).length > 0
    ) {
      toasterProps.current = getUndoToasterProps({
        message: objectType ? `${objectType} Reverted` : 'Reverted',
        onDismiss: () => {
          onUndo(originalObject);
        },
      });
      undoFunction(originalObject);
    }
  }, [undoObject]);

  const doUndo = () => {
    setUndoObject(originalObject);
  };

  const reset = (onSave = () => {}) => {
    setUndoObject(undefined);
    toasterProps.current = getSaveToasterProps({
      message: objectType ? `${objectType} Saved` : 'Saved',
      onDismiss: (didTimeoutExpire) => {
        didTimeoutExpire && onSave();
      },
      action: {
        onClick: doUndo,
        text: 'Undo',
      },
    });
  };

  const showToast = () => {
    toasterProps.current && BOSToasterRef.show(toasterProps.current);
  };

  return [reset, showToast];
};
